import { Link } from 'react-router-dom';
import PhoneButton from '@/components/base/PhoneButton';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20locksmith%20technician%20working%20on%20door%20lock%20at%20night%2C%20urban%20Istanbul%20street%20background%2C%20dramatic%20lighting%2C%20tools%20in%20hand%2C%20focused%20skilled%20worker%2C%20dark%20moody%20atmosphere%2C%20cinematic%20photography%20style%2C%20high%20quality&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Alfa Çilingir - 7/24 Profesyonel Çilingir Hizmeti"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 border border-orange-400/60 text-orange-300 text-xs font-semibold px-4 py-2 rounded-full mb-6 backdrop-blur-sm bg-white/5">
            <span className="w-2 h-2 flex items-center justify-center">
              <span className="w-2 h-2 bg-orange-400 rounded-full animate-ping absolute"></span>
              <span className="w-2 h-2 bg-orange-400 rounded-full relative"></span>
            </span>
            7/24 ACİL ÇİLİNGİR HİZMETİ
          </div>

          {/* Heading */}
          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-4">
            İstanbul'un En Hızlı<br />
            <span className="text-orange-400">Çilingir Hizmeti</span>
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-gray-200 mb-3 leading-relaxed">
            Kapınız kilitli mi kaldı? <strong className="text-white">15 dakikada</strong> yanınızdayız.
          </p>
          <div className="flex flex-wrap gap-2 mb-8">
            {['Beylikdüzü', 'Esenyurt', 'Büyükçekmece', 'Bahçeşehir'].map((b) => (
              <span key={b} className="bg-orange-500/20 border border-orange-400/40 text-orange-300 text-sm px-3 py-1 rounded-full">
                {b}
              </span>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <PhoneButton size="lg" />
            <Link
              to="/hizmetler"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/60 text-white hover:bg-white/10 font-semibold px-8 py-4 rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer text-lg"
            >
              Hizmetlerimiz
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-6 mt-10">
            {[
              { icon: 'ri-shield-check-line', text: 'Lisanslı Çilingir' },
              { icon: 'ri-timer-flash-line', text: '15 Dk. Yanınızda' },
              { icon: 'ri-24-hours-line', text: '7/24 Hizmet' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-gray-200 text-sm">
                <span className="w-8 h-8 flex items-center justify-center bg-orange-500/20 rounded-full text-orange-400">
                  <i className={`${item.icon} text-base`}></i>
                </span>
                {item.text}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/50 text-xs animate-bounce">
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-lg"></i>
        </span>
      </div>
    </section>
  );
}
